/* --------------------------------------------------
Import modules
-------------------------------------------------- */

import SimpleSelector from 'simple-selector';

/* --------------------------------------------------
Global variables
-------------------------------------------------- */

// Create an object to store all the selectors
window.SimpleSelectors = {};

/* --------------------------------------------------
Google translate hack
-------------------------------------------------- */

let translateTimeout = null;
const GoogleTranslateObserver = new MutationObserver(mutations => {
  clearTimeout(translateTimeout);
  translateTimeout = setTimeout(() => {
    const Select = window.SimpleSelectors['google-translate'];
    if (Select) {
      Select.close();
      Select.open();
      Select.events['change'] = [];
      Select.events['change'].push(() => {
        // Set the session storage item
        window.sessionStorage.setItem('google-translate-trigger', true);
        // Disconnect the observer
        GoogleTranslateObserver.disconnect();
      });
    }
  }, 100);
});

/* --------------------------------------------------
Selectors
-------------------------------------------------- */

DomObserver.observe('select', selects => {
  selects.forEach(select => {
    // Prepare for google translate
    if (select.className.includes('goog-te-combo')) {
      select.id = 'google-translate';
      select.setAttribute('placeholder', 'Select language');
      // If the user has already interacted with the trigger, we don't need to observe the select
      if (!window.sessionStorage.getItem('google-translate-trigger')) {
        GoogleTranslateObserver.observe(select, {
          childList: true
        });
      }
    }
    const Selector = new SimpleSelector(select, {
      search: select.options.length > 10 || select.id === 'google-translate'
    });
    select.SimpleSelector = Selector;
    window.SimpleSelectors[select.id] = Selector;
  });
});